import { useEffect, useState } from "react";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Explore", href: "#explore" },
  { label: "Gallery", href: "#gallery" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-[10] transition-all duration-300 ${
        scrolled
          ? "bg-white/70 backdrop-blur-md border-b border-black/5"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex items-center justify-between px-6 md:px-10 py-4">
        <a
          href="#home"
          className="flex items-center gap-2 text-black font-bold tracking-tight cursor-pointer"
          style={{ fontFamily: '"Montserrat", sans-serif' }}
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-black text-white text-sm">
            <i className="ri-sparkling-2-fill"></i>
          </span>
          <span className="text-lg">Aurora</span>
        </a>

        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                className="text-sm font-medium text-black/80 hover:text-black transition-colors cursor-pointer whitespace-nowrap"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#signin"
            className="text-sm font-medium text-black/80 hover:text-black transition-colors cursor-pointer whitespace-nowrap"
            style={{ fontFamily: '"Montserrat", sans-serif' }}
          >
            Sign in
          </a>
          <a
            href="#getstarted"
            className="text-sm font-semibold text-white bg-black hover:bg-black/85 transition-colors rounded-full px-4 py-2 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: '"Montserrat", sans-serif' }}
          >
            Get started
          </a>
        </div>

        <button
          type="button"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-full bg-white/60 backdrop-blur text-black cursor-pointer"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-white/90 backdrop-blur-md border-t border-black/5 px-6 py-4">
          <ul className="flex flex-col gap-3">
            {navLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="block text-sm font-medium text-black/80 hover:text-black cursor-pointer"
                  style={{ fontFamily: '"Montserrat", sans-serif' }}
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="pt-2 flex items-center gap-3">
              <a
                href="#signin"
                className="text-sm font-medium text-black/80 hover:text-black cursor-pointer whitespace-nowrap"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Sign in
              </a>
              <a
                href="#getstarted"
                className="text-sm font-semibold text-white bg-black hover:bg-black/85 rounded-full px-4 py-2 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Get started
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}